import { createReducer, on } from '@ngrx/store';
import * as SubscriptionPlansActions from '../actions/subscription-plans.actions';
import { UserActiveSubscription } from '../../models/subscription';

export interface State {
  plans: any[]; 
  userActiveSubscriptions: UserActiveSubscription[]; 
  errorMessage: string | null;
  isLoading: boolean;
  isLoadingUserSubscriptions: boolean;
}
export const initialState: State = {
  plans: [],
  userActiveSubscriptions: [],
  errorMessage: null,
  isLoading: false,
  isLoadingUserSubscriptions: false
};
export const subscriptionPlansReducer = createReducer(
  initialState,

  on(SubscriptionPlansActions.loadSubscriptionPlans, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: null
  })),

  on(SubscriptionPlansActions.loadSubscriptionPlansSuccess, (state, { plans }) => ({
    ...state,
    plans: plans,
    isLoading: false,
    errorMessage: null
  })),

  on(SubscriptionPlansActions.loadSubscriptionPlansFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    errorMessage: error
  })),
  on(SubscriptionPlansActions.userSubscribeToPlan, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: null
  })),
  on(SubscriptionPlansActions.userSubscribeToPlanSuccess, (state, { planId, userId }) => ({
    ...state,
    isLoading: false,
    errorMessage: null
  })),
  on(SubscriptionPlansActions.userSubscribeToPlanFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    errorMessage: error
  })),

  on(SubscriptionPlansActions.loadUserActiveSubscriptions, (state) => ({
    ...state,
    isLoadingUserSubscriptions: true,
    errorMessage: null
  })),

  on(SubscriptionPlansActions.loadUserActiveSubscriptionsSuccess, (state, { subscriptions }) => ({
    ...state,
    userActiveSubscriptions: subscriptions,
    isLoadingUserSubscriptions: false,
    errorMessage: null
  })),

  on(SubscriptionPlansActions.loadUserActiveSubscriptionsFailure, (state, { error }) => ({
    ...state,
    isLoadingUserSubscriptions: false,
    errorMessage: error
  }))

);
